module.exports = __webpack_public_path__ + "img/szgy.99958ab2.jpg";